import axios from "axios";
import { toast } from "react-toastify";
import companyAuthHeader from "./companyAuthHeader";

export const getCompanyPreferences = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company-admin/preferences`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateCompanyPreferences = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/company-admin/preferences`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const getCompanyDiscounts = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company-admin/discounts`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateCompanyDiscounts = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/company-admin/discounts`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const getCompanyFinancialYears = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company-admin/financial-years`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateCompanyFYLocking = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/company-admin/financial-years`,
        data,
        { headers: companyAuthHeader() }
      )
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const changeCompanyPassword = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/company-admin/change-password`,
        data,
        { headers: companyAuthHeader() }
      )
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const getModulesCatalog = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company-admin/modules-catalog`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const getUserPermissions = (userId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/company-admin/users/${userId}/permissions`,
        { headers: companyAuthHeader() }
      )
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateUserPermissions = (userId, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/company-admin/users/${userId}/permissions`,
        data,
        { headers: companyAuthHeader() }
      )
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const downloadCompanyBackup = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/company-admin/backup`, {
      headers: companyAuthHeader(),
      responseType: "blob",
    })
    .then((res) => {
      const disposition = res.headers["content-disposition"];
      let filename = "backup.sql";
      if (disposition) {
        const match = disposition.match(/filename="(.+)"/);
        if (match) filename = match[1];
      }

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Backup downloaded successfully");
      return true;
    })
    .catch((err) => {
      if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
      else toast.error("Backup download failed");
      throw err;
    });
};
